import Box from "@mui/material/Box"
import Divider from "@mui/material/Divider"
import React, { } from "react";
import Typography from "@mui/material/Typography";
import GraduationIcon from "@/icons/Graduation";
import SuitcaseIcon from "@/icons/Suitcase";
import { getUserDetails } from "@/utils/getUserDetails";
import { EDUCATION_INSIGHTS_MAP, EXPERIENCE_INSIGHTS_MAP, estimateNoticeTooltipMessage, estimateSalaryTooltipMessage, gulfInsights } from "@/constants/fm";
import { transformInsights } from "@/utils/index";
import InfoTooltip from "@/components/common/tooltip/InfoTooltip";
import ToolTip from "@/icons/Tooltip";
import { BELOW_50_K, salaryFormatter, getConfidentialSalaryRange } from "@/utils/userProfileCard";
import { Nullish } from "@/types/index";

function decodeExtraHtml(html:any) {
  return html.replace(/\\?\\(?:#x([0-9a-fA-F]+)|#([0-9]+)|(\w+));?/g, function (match:any, hex:any, dec:any, entity:any) {
      if (hex !== undefined) {
          return String.fromCharCode(parseInt(hex, 16));
      } else if (dec !== undefined) {
          return String.fromCharCode(parseInt(dec, 10));
      } else {
          // Handle named entities if needed
          return match;
      }
  });
}
export function decodeHtml(val:any) {
  var txt = document.createElement("textarea");
  txt.innerHTML = val;
  return decodeExtraHtml((txt.value)?.toString()?.replaceAll('\#x26;', ''))?.replace(/\.([^\s])/g, '.$1')?.replace(/<\/?[^>]+(>|$)/g, "");
}

export function getRequiredCtcDetails(
  ctc: Nullish<number>,
  finalCtc: Nullish<number>,
  salaryMode: Nullish<string>,
  currencyCode: Nullish<string>,
  isSalaryConfidential: boolean,
  predictedMaxCtc?:number,
  predictedMInCtc?:number,
  predicted_salary_mode?:string,
  predicted_currency_code?:string

) {

  let salaryNumber: number | string;

  // if (isSalaryConfidential === null || isSalaryConfidential === undefined) {
  //   return "-"
  // }
  // if (predictedMaxCtc === undefined || predictedMInCtc === undefined){
  //   return "-"
  // }
  

  

  // if (currencyCode === null || currencyCode === undefined) {
  //   return "-"
  // }

  const isChannelOne = Number(getUserDetails()?.channel_id) === 1;

  const salaryInterceptor = (salary: string, addRupee: boolean = true, isINR: boolean = true) => {
    if(salary.includes(BELOW_50_K)) {
      return 'Below \u20B9 50 k'
    } else {
      return (addRupee && isINR) ? `\u20B9 ${salary}` : salary;
    }
  }

  if (isSalaryConfidential && 
    ((predicted_currency_code && predicted_currency_code?.toUpperCase() !=='INR') || 
    (currencyCode && currencyCode?.toUpperCase() !== "INR"))) {
    return "Confidential"
  }

  if ((finalCtc === null || finalCtc === undefined) && (ctc === null || ctc === undefined) && (predictedMaxCtc === undefined || predictedMInCtc === undefined)) {
    return "-"
  }
  let isINRCurrency = false
  if(predicted_currency_code?.toUpperCase() ==='INR'){
    isINRCurrency= true
  }
  if (predictedMaxCtc && predictedMInCtc ){
    const CURRENCY_CODE = isINRCurrency ? '' : (predicted_currency_code?.toUpperCase() + ' '); //for rupee symbol
    if (isChannelOne) {
      if(predicted_salary_mode === "Monthly") {
        return `${CURRENCY_CODE}${salaryInterceptor(salaryFormatter(predictedMInCtc * 12,isChannelOne,isINRCurrency),true, isINRCurrency)} - ${salaryInterceptor(salaryFormatter(predictedMaxCtc * 12,isChannelOne,isINRCurrency), false)}`;
      }
      else { 
        return `${CURRENCY_CODE}${salaryInterceptor(salaryFormatter(predictedMInCtc,isChannelOne,isINRCurrency), true, isINRCurrency)} - ${salaryInterceptor(salaryFormatter(predictedMaxCtc,isChannelOne,isINRCurrency), false)}`;
      } 
    } else {
      if(predicted_salary_mode === "Annually") {
        return `${CURRENCY_CODE}${isINRCurrency?salaryInterceptor(Math.round(Number(predictedMInCtc/12))?.toLocaleString('en-IN')) :Math.round(Number(predictedMInCtc/12))?.toLocaleString()} - ${isINRCurrency?salaryInterceptor(Math.round(Number(predictedMaxCtc/12))?.toLocaleString('en-IN')) :Math.round(Number(predictedMaxCtc/12))?.toLocaleString()}`
      } else {
        return `${CURRENCY_CODE}${isINRCurrency?salaryInterceptor(predictedMInCtc?.toLocaleString('en-IN')): predictedMInCtc?.toLocaleString()} - ${isINRCurrency?salaryInterceptor(predictedMaxCtc?.toLocaleString('en-IN')):predictedMaxCtc?.toLocaleString()}`
      }
    }
  }
  if (isChannelOne) {
    if (currencyCode?.toUpperCase() === "INR") {
      if (salaryMode === "Monthly") {
        salaryNumber = finalCtc ? finalCtc : ctc ? ctc * 12 : "-";
      }
      else {
        salaryNumber = finalCtc ? finalCtc : ctc ? ctc : "-";
      }
    } else {
      if (salaryMode === "Monthly") {
        salaryNumber = ctc ? ctc * 12 : finalCtc ? finalCtc : "-";
      }
      else {
        salaryNumber = ctc ? ctc : finalCtc ? finalCtc : "-";
      }
    }
  }
  else {
    if (salaryMode === "Monthly") {
      salaryNumber = ctc ? ctc : finalCtc ? finalCtc / 12 : "-";
    }
    else {
      salaryNumber = ctc ? ctc / 12 : finalCtc ? finalCtc / 12 :  "-";
    }
  }

  if(!currencyCode){
    return '-'
    }
    else if (currencyCode?.toUpperCase() === "INR") {
      if(isSalaryConfidential && typeof salaryNumber === 'number'){
        return `\u20B9 ${getConfidentialSalaryRange(salaryNumber)}`;
      }
      return `${salaryInterceptor(salaryFormatter(salaryNumber,true,true))}`
    }
    else {
      return `${currencyCode} ${Math.ceil(Number(salaryNumber))?.toLocaleString()}`
    }
  }
	function trimToWordLimit(input:string, maxLength:number) {
		if (input.length <= maxLength) return input;
	
		// Trim the string to the max length
		let trimmed = input.slice(0, maxLength);
	
		// Find the last space within the trimmed string
		let lastSpaceIndex = trimmed.lastIndexOf(' ');
	
		// If a space was found, cut the string at the last space
		if (lastSpaceIndex !== -1) {
			return trimmed.slice(0, lastSpaceIndex);
		}
	
		// If no space is found, return the trimmed string as-is
		return trimmed;
	}
const ProfileCardRightBody = (props: any) => {
  
  const {
    experience,
    industries,
    pastIndustries,
    predicatedSalary,
    functions,
    roles,
    currentWorkExperienceInsight,
    educationInsight,
    workExperienceInsight,
    experienceInsight,
    description,
    totalExperience,
    salary,
    noticePeriod,
    noticePeriodValue,
    estimateNoticePeriod,
    insightTooltips
  } = props.data;

  const channelId = getUserDetails()?.channel_id;
 
  const [showMore, setShowMore] = React.useState(true)
  const [showMoreExp, setShowMoreExp] = React.useState(false)
  const [showMoreEdu, setShowMoreEdu] = React.useState(false)
  const [rolesShowMore, setRolesShowMore] = React.useState(true)
  const [descriptionShowMore, setDescriptionShowMore] = React.useState(true)
  const [industriesShowMore, setIndustriesShowMore] = React.useState(true)
  const [pastIndustriesShowMore, setPastIndustriesShowMore] = React.useState(true)

  const functionsList = showMore ? functions?.slice(0, 20) : functions?.slice(0,)
  const industriesList = industriesShowMore ? industries?.slice(0, 20) : industries?.slice(0,)
  const pastIndustriesList = pastIndustriesShowMore ? pastIndustries?.slice(0, 20) : pastIndustries?.slice(0,)
  const rolesList = rolesShowMore ? roles?.slice(0, 20) : roles?.slice(0,)
  const shouldShowMoreDescription = description?.slice(200,)?.length > 0
  const descriptionText = description?.length > 0 ?descriptionShowMore && shouldShowMoreDescription ? trimToWordLimit(description,200)+'... ' : description?.slice(0,) :''
  const domain = window.location.hostname;
  const isGulfDomain = domain.includes("founditgulf");
  const transformedEducationInsights = transformInsights(educationInsight,!isGulfDomain? EDUCATION_INSIGHTS_MAP:[...EDUCATION_INSIGHTS_MAP,...gulfInsights]) 
  const transformedExpInsights =  transformInsights(experienceInsight, EXPERIENCE_INSIGHTS_MAP).filter((item: any) => !["loyal", "is_likely_to_explore"].includes(item.key))
  const noticePeriodText = noticePeriodValue > 90 ? 'More than 90 days' : noticePeriod; 
  const fontSizeWeight = {fontSize: "14px", fontWeight: 510};

  return (
    <Box sx={{ padding: "8px 16px" }}>
      <Box sx={{ padding: "8px 12px", borderRadius: "8px", background: "var(--clr-grey-7)" }}>
     {descriptionText?.length > 0 && <Box sx={{ overflowY: descriptionText?.length > 850 ? "scroll" : "visible", height: descriptionText.length > 850 ? "300px" : "fit-content" }}>
          <Typography sx={{ fontSize: "14px", color: "#565365" ,whiteSpace:'pre-wrap'}} >
            {decodeHtml(descriptionText) || ''}
            {shouldShowMoreDescription ? (
              descriptionShowMore ? (
                <Typography
                  sx={{ fontSize: "14px", textDecoration: "underline", cursor: "pointer", lineHeight: "2em", display: "inline" }}
                  onClick={() => setDescriptionShowMore(false)}
                >
                  read more
                </Typography>
              ) : (
                <>
                <Typography
                  sx={{ fontSize: "14px", cursor: "pointer", lineHeight: "2em", display: "inline",flexDirection:'row-reverse' }}
                  onClick={() => setDescriptionShowMore(true)}
                >
                  {` `}
  
                 <span style={{textDecoration: "underline"}}>read less</span>
                </Typography>
                </>
              )
            ) : null}
          </Typography>
        </Box> }   
       {descriptionText?.length > 0 && <Divider sx={{ paddingTop: "8px" }} />} 
        <Box sx={{ display: "flex", direction: "column", paddingTop: "8px", gap: "10px" }}>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: "14px", color: "#565365" }}>Total experience</Typography>
            <Typography sx={{...fontSizeWeight}}>{totalExperience || ''}</Typography>
          </Box>
          <Divider orientation="vertical" flexItem />
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: "flex" }}>
              <Typography sx={{ flex: 5, fontSize: "14px", color: "#565365" }}>{predicatedSalary ? `Expected CTC (${channelId === "1" ? 'Annually' : 'Monthly'})` : channelId === "1" ? "CTC Annually" : "CTC Monthly"}</Typography>
              {predicatedSalary && <Typography sx={{ flex: 1 }}> <ToolTip title={estimateSalaryTooltipMessage} /></Typography>}
            </Box>
            {salary && <Typography sx={{ ...fontSizeWeight }}>{salary}</Typography>}
          </Box>
          <Divider orientation="vertical" flexItem />
          <Box sx={{ flex: 1.2 }}>
            <Box sx={{ display: "flex" }}>
              <Typography sx={{ flex: 5, fontSize: "14px", color: "#565365" }}>{estimateNoticePeriod ? "Estimated notice period" : "Notice period"}</Typography>
              {estimateNoticePeriod && <Typography sx={{ flex: 1 }}> <ToolTip title={estimateNoticeTooltipMessage} /></Typography>}
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography sx={{ ...fontSizeWeight, color: "black" }}>{noticePeriod.includes("LWD") ? "Serving Notice Period" : ""}</Typography>
              <Typography sx={{ ...fontSizeWeight, color: noticePeriod.includes("LWD") || noticePeriod.includes("Immediate") ? "#62ba46" : "black" }}>{noticePeriodText}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {
       !descriptionShowMore? "" :
          <>
            <Box sx={{ padding: "8px 0px" }}>
           
{ industriesList?.length >0 && <Box sx={{ display: "flex", alignItems: "start", padding: "2px 0px", gap: "8px" }}>
                <Typography sx={{ fontSize: "14px", color: "#565365", padding: "2px 0px", flex: 1 }}>Current Industries:</Typography>
                <Box sx={{ flex: 4, display: "flex", gap: "4px", flexWrap: "wrap" }}>
                  {industriesList?.map((industry: string, index: number) => <Typography sx={{ fontSize: "14px", color: "#565365", padding: "2px 0px" }}>{industry}{index !== (industries.length - 1) ? ', ' : ''}</Typography>)}
                  {industries?.slice(20,)?.length > 0 ? (
                    industriesShowMore ? (
                      <Typography
                        sx={{ fontSize: "14px", color: "var(--clr-secondary-free-speech-blue)", textDecoration: "underline", cursor: "pointer", lineHeight: "2em" }}
                        onClick={() => setIndustriesShowMore(false)}
                      >
                        +{industries.slice(20,).length} more
                      </Typography>
                    ) : (
                      <Typography
                        sx={{ fontSize: "14px", color: "var(--clr-secondary-free-speech-blue)", textDecoration: "underline", cursor: "pointer", lineHeight: "2em" }}
                        onClick={() => setIndustriesShowMore(true)}
                      >
                        Show less
                      </Typography>
                    )
                  ) : null}
                </Box>
              </Box> }
              {pastIndustries?.length > 0 &&    <Box sx={{ display: "flex", alignItems: "start", padding: "2px 0px", gap: "8px" }}>
                <Typography sx={{ fontSize: "14px", color: "#565365", padding: "2px 0px", flex: 1 }}>Past Industries:</Typography>
                <Box sx={{ flex: 4, display: "flex", gap: "4px", flexWrap: "wrap" }}>
                  <Typography sx={{ fontSize: "14px", color: "#565365", padding: "2px 0px" }}>{pastIndustriesList?.join(', ')}</Typography>
                  {pastIndustries?.slice(20,)?.length > 0 ? (
                    pastIndustriesShowMore ? (
                      <Typography
                        sx={{ fontSize: "14px", color: "var(--clr-secondary-free-speech-blue)", textDecoration: "underline", cursor: "pointer", lineHeight: "2em" }}
                        onClick={() => setPastIndustriesShowMore(false)}
                      >
                        +{pastIndustries.slice(20,).length} more
                      </Typography>
                    ) : (
                      <Typography
                        sx={{ fontSize: "14px", color: "var(--clr-secondary-free-speech-blue)", textDecoration: "underline", cursor: "pointer", lineHeight: "2em" }}
                        onClick={() => setPastIndustriesShowMore(true)}
                      >
                        Show less
                      </Typography>
                    )
                  ) : null}
                </Box>
              </Box>}
           
              {(totalExperience == 0 || totalExperience?.toLowerCase() =="fresher" ) &&  <Box sx={{ display: "flex", alignItems: "start", padding: "2px 0px", gap: "8px" }}>
                <Typography sx={{ fontSize: "14px", color: "#565365", padding: "2px 0px", flex: 1 }}>Pf. designation:</Typography>
                <Box sx={{ flex: 4, display: "flex", gap: "4px", flexWrap: "wrap" }}>
                  {rolesList?.map((role: string, index: number) => <Typography sx={{ fontSize: "14px", padding: "2px 0px", color: "#565365" }}>{role}{index !== (roles.length - 1) ? ', ' : ''}</Typography>)}
                  {roles?.slice(20,)?.length > 0 ? (
                    rolesShowMore ? (
                      <Typography
                        sx={{ fontSize: "14px", color: "var(--clr-secondary-free-speech-blue)", textDecoration: "underline", cursor: "pointer", lineHeight: "2em" }}
                        onClick={() => setRolesShowMore(false)}
                      >
                        +{roles.slice(20,).length} more
                      </Typography>
                    ) : (
                      <Typography
                        sx={{ fontSize: "14px", color: "var(--clr-secondary-free-speech-blue)", textDecoration: "underline", cursor: "pointer", lineHeight: "2em" }}
                        onClick={() => setRolesShowMore(true)}
                      >
                        Show less
                      </Typography>
                    )
                  ) : null}
                </Box>
              </Box>
}
          {functions?.length> 0 && functions?.[0]!=='-' &&  
           <Box sx={{ display: "flex", alignItems: "start", padding: "2px 0px", gap: "8px" }}>
                <Typography sx={{ fontSize: "14px", padding: "2px 0px", color: "#565365", flex: 1 }}>Pf. function:</Typography>
                <Box sx={{ flex: 4, display: "flex", gap: "4px", flexWrap: "wrap" }}>
                  <>
                    {/* {functionsList.map((func: string) => <Typography sx={{ fontSize: "14px", padding: "2px 0px" }}>{func}</Typography>)}
                {functions.slice(5,).length > 0 ? (
                  showMore ? (
                    <Typography
                      sx={{ fontSize: "14px", color: "var(--clr-secondary-free-speech-blue)", textDecoration: "underline", cursor: "pointer", lineHeight: "2em" }}
                      onClick={() => setShowMore(false)}
                    >
                      +{functions.slice(20,).length} more
                    </Typography>
                  ) : (
                    <Typography
                      sx={{ fontSize: "14px", color: "var(--clr-secondary-free-speech-blue)", textDecoration: "underline", cursor: "pointer", lineHeight: "2em" }}
                      onClick={() => setShowMore(true)}
                    >
                      Show less
                    </Typography>
                  )
                ) : null} */}

                    <Typography sx={{ fontSize: "14px", color: "#565365", padding: "2px 0px" }}>{functions}</Typography>
                  </>
                </Box>
              </Box>
          }
            </Box>

            <Box sx={{ padding: "8px 0px" }}>
              {/* {currentWorkExperienceInsight[0] !== "N/A" &&
            <Box sx={{ display: "flex", alignItems: "flex-start", padding: "2px 0px", gap: "4px" }}>
              <Box sx={{ padding: "4px", backgroundColor: "var(--clr-grey-7)", borderRadius: "4px" }}>
                <ProfileIcon />
              </Box>
              <Box sx={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
                {currentWorkExperienceInsight.map((value: string) => (
                  <Box
                    sx={{
                      padding: "4px 8px",
                      borderRadius: "4px",
                      borderColor: "var(--clr-secondary-quartz)",
                      backgroundColor: "var(--clr-secondary-quartz)",
                      color: "var(--clr-secondary-free-speech-blue)",
                      fontSize: "14px"
                    }}
                  >
                    {transformString(value)}
                  </Box>
                ))}
              </Box>
            </Box>
          } */}

              {transformedExpInsights.length > 0 &&
                <Box sx={{ display: "flex", alignItems: "flex-start", padding: "2px 0px", gap: "4px" }}>
                  <Box sx={{ padding: "4px", backgroundColor: "var(--clr-grey-7)", borderRadius: "4px" }}>
                    <SuitcaseIcon />
                  </Box>

                  <Box sx={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
                    {(!showMoreExp ?transformedExpInsights.slice(0,4):transformedExpInsights)?.map((value: any) => (
                      <InfoTooltip title={insightTooltips[value.key]} icon={
                        <Box
                          sx={{
                            padding: "4px 8px",
                            borderRadius: "4px",
                            borderColor: "var(--clr-secondary-quartz)",
                            backgroundColor: "var(--clr-secondary-quartz)",
                            color: "var(--clr-secondary-free-speech-blue)",
                            fontSize: "14px",
                            cursor: "pointer"
                          }}
                        >
                          {value.text}
                        </Box>
                      } />
                    ))}
                    {transformedExpInsights.length >4 &&
                    (!showMoreExp? (
                <Typography
                  sx={{ fontSize: "14px", color: "var(--clr-secondary-free-speech-blue)", textDecoration: "underline", cursor: "pointer", lineHeight: "2em", display: "inline", paddingLeft: "8px" }}
                  onClick={() => setShowMoreExp(true)}
                >
                  +{transformedExpInsights.length-4} more
                </Typography>
              ) : (
                <Typography
                  sx={{ fontSize: "14px", color: "var(--clr-secondary-free-speech-blue)", textDecoration: "underline", cursor: "pointer", lineHeight: "2em", display: "inline", paddingLeft: "8px" }}
                  onClick={() => setShowMoreExp(false)}
                >
                  Show less
                </Typography>
              ))}
                  </Box>
                </Box>
              }

              {
                transformedEducationInsights.length > 0 &&
                <Box sx={{ display: "flex", alignItems: "flex-start", padding: "2px 0px", gap: "4px" }}>
                  <Box sx={{ padding: "4px", backgroundColor: "var(--clr-grey-7)", borderRadius: "4px" }}>
                    <GraduationIcon />
                  </Box>
                  <Box sx={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
                    {(!showMoreEdu ?transformedEducationInsights.slice(0,4):transformedEducationInsights)?.map((value: any) => (
                      <InfoTooltip title={insightTooltips[value.key]} icon={
                        <Box
                          sx={{
                            padding: "4px 8px",
                            borderRadius: "4px",
                            borderColor: "var(--clr-secondary-quartz)",
                            backgroundColor: "var(--clr-secondary-quartz)",
                            color: "var(--clr-secondary-free-speech-blue)",
                            fontSize: "14px",
                            cursor: "pointer"
                          }}
                        >
                          {value.text}
                        </Box>
                      } />
                    ))}
                    {transformedEducationInsights.length >4 &&
                    (
                    !showMoreEdu? (
                <Typography
                  sx={{ fontSize: "14px", color: "var(--clr-secondary-free-speech-blue)", textDecoration: "underline", cursor: "pointer", lineHeight: "2em", display: "inline", paddingLeft: "8px" }}
                  onClick={() => setShowMoreEdu(true)}
                >
                  +{transformedEducationInsights.length-4} more
                </Typography>
              ) : (
                <Typography
                  sx={{ fontSize: "14px", color: "var(--clr-secondary-free-speech-blue)", textDecoration: "underline", cursor: "pointer", lineHeight: "2em", display: "inline", paddingLeft: "8px" }}
                  onClick={() => setShowMoreEdu(false)}
                >
                  Show less
                </Typography>
              ))}
                  </Box>
                </Box>
              }
            </Box>
          </>
      }
    </Box>
  )
}

export default ProfileCardRightBody